import React from 'react';
import PropTypes from 'prop-types';
import { PhotoIcon } from '@heroicons/react/24/outline';

// TODO: These should go in a database table somewhere. For now is OK.
const exampleProjects = [
  {
    "id": 2246,
    "title": "Building Carpentry Skills & Community",
    "excerpt": "David Cullison, an educator at Fourth Avenue Junior High School in Yuma, wanted to give his students an opportunity to develop their carpentry skills by creating a woodworking project from scratch. And, he wanted to take the project a step further by encouraging students to contribute their gifts to the broader community.",
    "imageUrl": "https://www.communityshare.org/wp-content/uploads/2024/04/copy-of-saaw-adj.jpg",
    "link": "https://www.communityshare.org/portfolio-posts/building-carpentry-skills-and-community/"
  },
  {
    "id": 2515,
    "title": "From Fast Fashion to Lasting Change",
    "excerpt": "In Elii Chapman\u2019s 4th and 5th-grade art class, waste produced by the \u201cfast fashion\u201d industry sparked a powerful, interdisciplinary learning experience\u2014one that connected global environmental issues, local community needs, and meaningful partnerships with higher education and community organizations.",
    "imageUrl": "https://www.communityshare.org/wp-content/uploads/2025/06/screenshot-2025-06-10-162806.png",
    "link": "https://www.communityshare.org/portfolio-posts/from-fast-fashion-to-lasting-change/"
  },
  {
    "id": 2524,
    "title": "Writing Our Own Stories: Literacy Through Storytelling",
    "excerpt": "Kindergarten teacher Mercedes Pemberton-Negrete was searching for ways to engage her students and build the literacy skills many of her students were struggling with. Looking for support, she shared her project with CommunityShare and was connected to Navajo author, Daniel Vandever, who led a transformative learning experience for students.",
    "imageUrl": "https://www.communityshare.org/wp-content/uploads/2025/06/dv_storytelling-project.jpg",
    "link": "https://www.communityshare.org/portfolio-posts/writing-our-own-stories-literacy-through-storytelling/"
  },
  {
    "id": 2278,
    "title": "Igniting Passion for Healthcare Careers",
    "excerpt": "High school students in Las Cruces New Mexico embarked on a journey into the world of medicine. Their CommunityShare project provided a glimpse into the diverse career paths and real-world environment of the healthcare field.",
    "imageUrl": "https://www.communityshare.org/wp-content/uploads/2024/06/nursing-project.jpg",
    "link": "https://www.communityshare.org/portfolio-posts/igniting-passion-for-healthcare-careers/"
  }
]

ExampleProjectCard.propTypes = {
  project: PropTypes.shape({
    id: PropTypes.number.isRequired,
    imageUrl: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
  })
};

function ExampleProjectCard(props) {
  const { project } = props;

  if (!project) return null

  let imageUrl = project.imageUrl;
  if (imageUrl?.startsWith('https://cdn.filestackcontent.com/')) {
    imageUrl = imageUrl.replace('https://cdn.filestackcontent.com/', 'https://cdn.filestackcontent.com/resize=width:600/');
  }

  return (
    <div className="bg-white rounded-cs-10 overflow-hidden flex flex-col h-80 md:h-[300px]">
      <div className="flex-1 min-h-0 bg-cs-gray-100 flex items-center justify-center">
        {imageUrl ? (
          <img src={imageUrl} alt={project.title || ''} className="w-full h-full object-cover object-top lg:object-center" />
        ) : (
          <PhotoIcon className="w-12 h-12 text-cs-gray-300" aria-hidden="true" />
        )}
      </div>
      <div className="p-4 flex-shrink-0 flex flex-col gap-2">
        <p className="text-lg font-semibold text-cs-gray-900 leading-snug">{project?.title || '—'}</p>
        <a
          href={project.link}
          target="_blank"
          rel="noopener noreferrer"
          className="self-start text-cs-navy-800 text-sm underline hover:opacity-75 focus:outline-none focus-visible:ring-2 focus-visible:ring-black rounded-sm"
        >
          View project
        </a>
      </div>
    </div>
  );
}

export default function ExampleProjects() {

  // return <pre>{JSON.stringify(projects, null, 2)}</pre>

  return (
    <div className="grid gap-4 grid-cols-1 md:grid-cols-2">
      {exampleProjects.map((p) => (
        <ExampleProjectCard key={p.id} project={p} />
      ))}
    </div>
  );
}
